export default __webpack_public_path__ + "static/media/er5.bc592b79.png";